import mutations from './mutations'
import actions from "./actions";
const auth = {
    namespaced: true,
    state: {
        authInfo: {},
        wareCode: '', // 所选仓库code
    },
    mutations,
    actions,
}
export default auth